import {Component, EventEmitter, input, Input, Output, signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {TableModule} from 'primeng/table';
import {ButtonModule} from 'primeng/button';
import {CheckboxModule} from 'primeng/checkbox';
import {TranslateModule} from '@ngx-translate/core';
import {isNotNullOrUndefined} from 'sigale-angular';
import {UtilisateurDto} from 'src/app/shared/dto/utilisateur.dto';
import {GroupeDeTravailDto} from '../../../gestion-equipe/onglets-gestion-equipe/groupe-de-travail/model/groupe-de-travail.dto';
import {EquipeDto} from '../../../gestion-equipe/onglets-gestion-equipe/equipe/model/equipe.dto';
import {UtilisateurSigalettService} from 'src/app/shared/services/utilisateur-sigalett.service';
import {UtilisateurSigalettBuilder} from 'src/app/shared/models/utilisateur-sigalett-builder';
import {UtilisateurSigalett} from 'src/app/shared/models/utilisateur-sigalett.model';

@Component({
	selector: 'app-ajout-utilisateur',
	templateUrl: './ajout-utilisateur.component.html',
	styleUrls: ['./ajout-utilisateur.component.scss'],
	standalone: true,
	imports: [
		CommonModule,
		FormsModule,
		AutoCompleteModule,
		TableModule,
		ButtonModule,
		CheckboxModule,
		TranslateModule
	]
})
export class AjoutUtilisateurComponent {

	loadingAjouterUtilisateur = signal<boolean>(false);
	loadingTableUtilisateur = signal<boolean>(false);
	protected readonly isNotNullOrUndefined = isNotNullOrUndefined;
	utilisateursSelectionnes: UtilisateurDto[] = [];
	@Input() entityGestionEquipe: GroupeDeTravailDto | EquipeDto;
	@Input() typeEntity: 'equipe' | 'groupeDeTravail';
	@Input() labelBouttonAjouter: string = '';
	@Input() utilisateurAAjouter: UtilisateurDto | null = null;
	@Input() utilisateursSuggestions: UtilisateurSigalett[] = [];
	@Input() optionLabel: string | ((u: UtilisateurSigalett) => string) = (user: UtilisateurSigalett) => user.recupererPrenomNom();
	@Input() forceSelection: boolean = true;
	@Input() showClear: boolean = true;
	@Input() emptyMessage: string = 'Aucun utilisateur trouvé';
	tailleScrollTable = input<number>(400);

	@Output() ajouterUtilisateur = new EventEmitter<void>();
	@Output() utilisateurAAjouterChange = new EventEmitter<UtilisateurDto | null>(); // pour ngModel
	@Output() completeMethod = new EventEmitter<string>();
	@Output() utilisateursTrouves = new EventEmitter<UtilisateurSigalett[]>();
	@Output() retirerUtilisateursEvent = new EventEmitter<string[]>();
	@Output() utilisateursSelectionnesChange = new EventEmitter<UtilisateurDto[]>();
	@Output() retirerUtilisateurs = new EventEmitter<void>();

	constructor(private utilisateurSigalettService: UtilisateurSigalettService) {
	}

	/**
	 * Recherche un utilisateur en base ou dans l'annuaire.
	 *
	 * @param $event le chaîne de caractère correspondant à un prénom, un nom ou un login.
	 */
	public rechercherUtilisateurs($event: { originalEvent: InputEvent, query: string }): void {
		if (isNotNullOrUndefined($event.query) && $event.query !== '') {
			this.utilisateurSigalettService.rechercherUtilisateursPourAutocomplete($event.query).subscribe((utilisateurs: UtilisateurDto[]) => {
				this.utilisateursSuggestions = utilisateurs
					.map((utilisateur: UtilisateurDto) => {
						const utilisateurBuilder: UtilisateurSigalettBuilder = new UtilisateurSigalettBuilder();
						return utilisateurBuilder
							.setLogin(utilisateur.login)
							.setFirstName(utilisateur.prenom)
							.setLastName(utilisateur.nom)
							.build();
					});
				this.utilisateursTrouves.emit(this.utilisateursSuggestions);

			});
		}
	}

	isButtonAjouterUtilisateurDisabled(): boolean {
		return this.utilisateurAAjouter === null || this.utilisateurAAjouter === undefined;
	}

	/**
	 * Vérifie si le bouton retirer est désactivé
	 */
	isButtonRetirerUtilisateurDisabled(): boolean {
		return !this.utilisateursSelectionnes || this.utilisateursSelectionnes.length <= 0;
	}

	/**
	 * Émet l'événement vers le parent pour retirer les utilisateurs
	 */
	onRetirerUtilisateurs(): void {
		this.retirerUtilisateurs.emit();
	}

	/**
	 * Met à jour la sélection
	 */
	onSelectionChange(selection: UtilisateurDto[]): void {
		this.utilisateursSelectionnes = selection;
		this.utilisateursSelectionnesChange.emit(selection);
	}

	renseignerScrollHeight(): string {
		return `${this.tailleScrollTable()}px`;
	}
}
